import type { SVGMotionProps } from 'motion/react'
import { motion } from 'motion/react'

export const Smiley = ({
  isHovered,
  ...props
}: SVGMotionProps<SVGSVGElement> & { isHovered?: boolean }) => {
  return (
    <motion.svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="none"
      whileHover="hover"
      animate={isHovered ? 'hover' : undefined}
      {...props}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.3}
        d="M17.5 10a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0Z"
      />
      <motion.g
        transition={{ duration: 0.5, ease: 'easeInOut' }}
        initial={{ y: 0 }}
        variants={{ hover: { y: [0, -1, 2, 0] } }}
      >
        <path
          fill="currentColor"
          d="M12.725 11.393a.65.65 0 0 1 1.05.768c-.403.552-.969.993-1.628 1.294a5.187 5.187 0 0 1-2.145.456 5.186 5.186 0 0 1-2.145-.456c-.659-.3-1.226-.742-1.629-1.294a.651.651 0 0 1 1.05-.768c.257.351.638.66 1.12.88.48.219 1.034.338 1.604.338.57 0 1.124-.119 1.605-.339.481-.22.862-.528 1.118-.879Z"
        />
        <motion.path
          transition={{ duration: 0.1 }}
          initial={{ opacity: 0 }}
          variants={{ hover: { opacity: 1 } }}
          fill="currentColor"
          d="M6.18 9.094a.651.651 0 0 1-1.052-.767c.195-.267.462-.471.761-.608a2.32 2.32 0 0 1 .96-.205c.33 0 .662.069.961.205.299.137.566.341.76.608a.651.651 0 0 1-1.05.767.63.63 0 0 0-.25-.192 1.024 1.024 0 0 0-.42-.088c-.155 0-.3.033-.42.088a.63.63 0 0 0-.25.192Z"
        />
        <motion.path
          transition={{ duration: 0.1 }}
          initial={{ opacity: 0 }}
          variants={{ hover: { opacity: 1 } }}
          fill="currentColor"
          d="M12.48 9.094a.651.651 0 0 1-1.05-.767c.194-.267.461-.471.76-.608a2.32 2.32 0 0 1 .96-.205c.33 0 .662.069.96.205.3.137.567.341.762.608a.651.651 0 0 1-1.051.767.63.63 0 0 0-.25-.192 1.024 1.024 0 0 0-.421-.088c-.154 0-.3.033-.42.088a.63.63 0 0 0-.25.192Z"
        />
        <motion.path
          transition={{ duration: 0.1 }}
          initial={{ opacity: 1 }}
          variants={{ hover: { opacity: 0 } }}
          fill="currentColor"
          d="M8.125 8.438a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
        />
        <motion.path
          transition={{ duration: 0.1 }}
          initial={{ opacity: 1 }}
          variants={{ hover: { opacity: 0 } }}
          fill="currentColor"
          d="M13.75 8.438a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0Z"
        />
      </motion.g>
    </motion.svg>
  )
}
